import { render, staticRenderFns } from "./uploaded-receipts.vue?vue&type=template&id=0eca2b4e"
import script from "./uploaded-receipts.vue?vue&type=script&lang=js"
export * from "./uploaded-receipts.vue?vue&type=script&lang=js"
import style0 from "./uploaded-receipts.vue?vue&type=style&index=0&id=0eca2b4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports